import React from "react";

import { Box, useMediaQuery } from "@mui/material";

import CustomLineChart from "../../../../components/customLineChart/CustomLineChart";
import moment from "moment";

const BoxDistributionRegistration = ({ data }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const parsedDataset = data.map(({ date_verified, number_registration }) => ({
    date: date_verified,
    number: Number(number_registration),
  }));

  console.log(parsedDataset);

  return (
    <Box
      sx={{
        justifyContent: "center",
        alignSelf: "center",
      }}
    >
      <CustomLineChart
        dataset={parsedDataset}
        yDataKey="number"
        yScaleType="linear"
        xScaleType="band"
        xDataKey="date"
        width={300}
        height={isMobile ? 240 : 350}
        layout="vertical"
        series={[
          {
            dataKey: "number",
            label: "Distribuzione registrazioni",
            valueFormatter: (value) => `${value}`,
            color: "rgb(224, 202, 0)",
          },
        ]}
      />
    </Box>
  );
};

export default BoxDistributionRegistration;
